module.exports = __webpack_public_path__ + "img/plastics-img-3.73fe946d.png";